import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

type Variant = 'label' | 'inline' | 'text';

interface SubscriberBadgeProps {
  variant?: Variant;
  label?: string;
  tooltip?: string;
  sx?: object;
}

const defaultTooltip = 'サブスクリプション限定機能です';

const SubscriberBadge: React.FC<SubscriberBadgeProps> = ({
  variant = 'inline',
  label,
  tooltip = defaultTooltip,
  sx = {},
}) => {
  // label: InputLabel内に配置する用。テキスト + 小さいロックアイコン
  if (variant === 'label') {
    return (
      <Tooltip title={tooltip} arrow>
        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.4, ...sx }}>
          {label}
          <LockOutlinedIcon sx={{ fontSize: '1.2em', color: 'text.disabled' }} />
        </Box>
      </Tooltip>
    );
  }

  // text: 説明テキスト付き（フォーム下部等）
  if (variant === 'text') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ...sx }}>
        <LockOutlinedIcon sx={{ fontSize: '0.85rem', color: 'text.disabled' }} />
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          {label ?? tooltip}
        </Typography>
      </Box>
    );
  }

  // inline: コンパクトなアイコン + テキスト（カード内等）
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.4, ...sx }}>
      <LockOutlinedIcon sx={{ fontSize: '0.8rem', color: 'text.disabled' }} />
      <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.7rem' }}>
        {label ?? 'サブスクリプション限定'}
      </Typography>
    </Box>
  );
};

export default SubscriberBadge;
